import { render } from "./GenericTable.vue?vue&type=template&id=78fb84e5&ts=true"
import script from "./GenericTable.vue?vue&type=script&lang=ts"
export * from "./GenericTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__